// 토스페이먼츠 API 응답 타입 정의

export interface TossPaymentCard {
  company: string;
  number: string;
  installmentPlanMonths: number;
  isInterestFree: boolean;
  interestPayer?: string;
  approveNo: string;
  useCardPoint: boolean;
  cardType: string;
  ownerType: string;
  acquireStatus: string;
  receiptUrl: string;
}

export interface TossPaymentEasyPay {
  provider: string;
  amount: number;
  discountAmount: number;
}

export interface TossPaymentReceipt {
  url: string;
}

export interface TossPaymentCheckout {
  url: string;
}

export interface TossPaymentFailure {
  code: string;
  message: string;
}

export interface TossPaymentCancellation {
  cancelAmount: number;
  cancelReason: string;
  taxFreeAmount: number;
  taxExemptionAmount: number;
  refundableAmount: number;
  easyPayDiscountAmount: number;
  canceledAt: string;
  transactionKey: string;
  receiptKey?: string;
}

export interface TossPaymentData {
  version: string;
  paymentKey: string;
  type: string;
  orderId: string;
  orderName: string;
  mId: string;
  currency: string;
  method: string;
  totalAmount: number;
  balanceAmount: number;
  status: 'READY' | 'IN_PROGRESS' | 'WAITING_FOR_DEPOSIT' | 'DONE' | 'CANCELED' | 'PARTIAL_CANCELED' | 'ABORTED' | 'EXPIRED';
  requestedAt: string;
  approvedAt?: string;
  useEscrow: boolean;
  lastTransactionKey?: string;
  suppliedAmount: number;
  vat: number;
  cultureExpense: boolean;
  taxFreeAmount: number;
  taxExemptionAmount: number;
  isPartialCancelable: boolean;
  card?: TossPaymentCard;
  virtualAccount?: {
    accountType: string;
    accountNumber: string;
    bankCode: string;
    customerName: string;
    dueDate: string;
    refundStatus: string;
    expired: boolean;
    settlementStatus: string;
    refundReceiveAccount?: {
      bankCode: string;
      accountNumber: string;
      holderName: string;
    };
  };
  transfer?: {
    bankCode: string;
    settlementStatus: string;
  };
  mobilePhone?: {
    customerMobilePhone: string;
    settlementStatus: string;
    receiptUrl: string;
  };
  giftCertificate?: {
    approveNo: string;
    settlementStatus: string;
  };
  cashReceipt?: {
    type: string;
    receiptKey: string;
    issueNumber: string;
    receiptUrl: string;
    amount: number;
    taxFreeAmount: number;
  };
  cashReceipts?: Array<{
    receiptKey: string;
    orderId: string;
    orderName: string;
    type: string;
    issueNumber: string;
    receiptUrl: string;
    businessNumber: string;
    transactionType: string;
    amount: number;
    taxFreeAmount: number;
    issueStatus: string;
    failure?: TossPaymentFailure;
    customerIdentityNumber: string;
    requestedAt: string;
  }>;
  discount?: {
    amount: number;
  };
  cancels?: TossPaymentCancellation[];
  secret?: string;
  easyPay?: TossPaymentEasyPay;
  country: string;
  failure?: TossPaymentFailure;
  receipt?: TossPaymentReceipt;
  checkout?: TossPaymentCheckout;
}

// Supabase에서 저장되는 토스 결제 데이터 타입
export type TossPaymentStoredData = Partial<TossPaymentData>;

// 타입 가드 함수들
export function isTossPaymentData(data: unknown): data is TossPaymentData {
  return typeof data === 'object' && 
         data !== null && 
         'paymentKey' in data && 
         typeof (data as { paymentKey: unknown }).paymentKey === 'string';
}

export function hasTossPaymentCard(data: TossPaymentData): data is TossPaymentData & { card: TossPaymentCard } {
  return data.card !== undefined && data.card !== null;
}

export function hasTossPaymentReceipt(data: TossPaymentData): data is TossPaymentData & { receipt: TossPaymentReceipt } {
  return data.receipt !== undefined && data.receipt !== null;
}

export function hasTossPaymentEasyPay(data: TossPaymentData): data is TossPaymentData & { easyPay: TossPaymentEasyPay } {
  return data.easyPay !== undefined && data.easyPay !== null;
}